import React from 'react';
import DatasetRow from './DatasetRow';

const DatasetsTableRows = ({
  className,
  columns,
  items,
  onCheckBoxClick,
  selectable,
  theme,
}) => (
  items.map((item, index) => (
    <DatasetRow
      className={className}
      key={`datasets_table_row_${item.id}`}
      dataset={item}
      onCheckBoxClick={onCheckBoxClick}
      upward={index > 4}
      columns={columns}
      theme={theme}
      selectable={selectable}
    />
  ))
);

export default DatasetsTableRows;
